import React from 'react';
import PaymentSystemUnavailable from './components/paymentSystemUnavailable';

function App() {
  return <PaymentSystemUnavailable />;
}

export default App;
